class InputUpDownBase extends Component {
	constructor(el) {
		super(el);
		this.input = this.$find('input');
		this.min = +this.$el.dataset.min;
		this.max = +this.$el.dataset.max;
		this.incrementEl = this.$find('[data-increment]');
		this.decrementEl = this.$find('[data-decrement]');
		this.changeEvent = new Event('change', { 'bubbles': true });
		this.addEventListeners();
		this.updateDecrementState();
	}

	incrementValue() {
		this.input.value++;
		this.checkBoundaries();
		this.input.dispatchEvent(this.changeEvent);
		this.updateDecrementState();
	}

	decrementValue() {
		this.input.value--;
		this.checkBoundaries();
		this.input.dispatchEvent(this.changeEvent);
		this.updateDecrementState();
	}

	checkBoundaries() {
		if (this.input.value > this.max) {
			this.input.value = this.max;
		} else if (this.input.value < this.min) {
			this.input.value = this.min;
		}
	}

	checkKey(e) {
		if (e.which > 59 || e.which < 48) {
			e.preventDefault();
		}
	}

	updateDecrementState() {
		const value = parseInt(this.input.value, 10) || 0;
		if (value <= this.min) {
			this.decrementEl.classList.add('is-disabled');
		} else {
			this.decrementEl.classList.remove('is-disabled');
		}
	}

	addEventListeners() {
		this.incrementEl.addEventListener('click', () => this.incrementValue());
		this.decrementEl.addEventListener('click', () => this.decrementValue());
		this.input.addEventListener('input', () => {
			this.checkBoundaries();
			this.updateDecrementState();
		});
		this.input.addEventListener('keypress', (e) => this.checkKey(e));
	}
}
